import 'swiper/css/swiper.min.css';
import './diversity-inclusion.scss';

import Swiper from 'swiper/js/swiper.min.js';
import '@/utils/common.js';
import ScrollAnim from '@/utils/scroll-anim.js';
new ScrollAnim();

$(function () {
    let actionSwiper = new Swiper('.action-swiper', {
        loop: true,
        slidesPerView: 'auto',
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});
